import React, {useState, useEffect, useContext} from 'react';
import SLogo from "../../../assets/images/SLogo.png";
import {makeStyles, withStyles} from '@material-ui/core/styles';
import {useQuery, gql} from "@apollo/client";
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import {useHistory} from "react-router-dom";
import './Header.css';
import ProfileMenu from "../../menu/ProfileMenu";
import UserContext from "../../../context/UserContext";

// const GET_USER_DATA = gql`
//     query MyQuery {
//         General_DatosAsesores {
//             Apellido
//             Email
//             Nombre
//             Auth_Datos {
//                 picture
//             }
//         }
//     }`;

const useStyles = makeStyles((theme) => ({
    nombreMenu: {
        fontSize: '16px',
        color: '#f3f4f8',
        fontFamily: 'Ubuntu',
        fontWeight: 'bold',
    },
    imagenPerfil: {
        width: '48px', height: '48px', borderRadius: '50%',
        border: '2px solid #fff',
        margin: '0 10px',
        [theme.breakpoints.down('md')]: {
            margin: 0
        },
    },
    sancorLogo: {
        width:" 140px",
        height: "auto",
        marginLeft: "30px",
        cursor: 'pointer'
    },
    navBar: {
        position: "relative",
        backgroundColor: "#3D4977",
        clippath: "polygon(0 0, 100% 0, 100% 70px, 0 70px)",
        display: "flex",
        flexDirection: "row",
        justifyContent:"space-between",
        width: "100%",
        height: "70px",
    },
    navBarUserInfo: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        marginRight: "20px",
    },
    navBarUserInfoDivider: {
        transform: "rotate(90deg)",
        color: "#fff",
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
    },
    navBarUserInfoNameRole: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "self-end"
    },
}));

const Header = (props) => {
    const classes = useStyles();
    // const {data: userData} = useQuery(GET_USER_DATA, {
    //     fetchPolicy: "cache-first",
    //     onCompleted: getDatosUsuario,
    // });


    const {userName, userPicture} = useContext(UserContext)

    // const [datosUsuario, setDatosUsuario] = useState([]);
    const role = props.role;
    const history = useHistory();

    // async function getDatosUsuario() {
    //     let datos = userData.General_DatosAsesores[0];
    //     let usuarios = {};
    //
    //     if (typeof datos === "undefined") {
    //         alert("Debe estar registrado para ingresar aqui")
    //         history.push('/')
    //     } else {
    //         usuarios = {
    //             "nombre": datos.Nombre + ' ' + datos.Apellido,
    //             "email": datos.Email,
    //             "imagen": datos.Auth_Datos.picture,
    //             "telefono": datos.Telefono,
    //         };
    //     }
    //     setDatosUsuario(usuarios);
    // }


    return (
        <React.Fragment>
            <div className={classes.navBar}>
                    <img
                        className={classes.sancorLogo}
                        src={SLogo}
                        alt="SLogo"
                        onClick={() => {
                            history.push({pathname: '/u/dashboard'})
                            if (role === "Asesor") {
                                history.push({pathname: '/u/dashboard'})
                            } else if (role === "Administrador") {
                                history.push({pathname: '/u/m/dashboard'})
                            }
                        }}
                    />
                <div className={classes.navBarUserInfo}>
                    <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                        <NotificationsNoneIcon style={{fill: "#fff"}}/>
                    </div>
                    <div className={classes.navBarUserInfoDivider}>
                        <HorizontalRuleIcon/>
                    </div>

                    <div className={classes.navBarUserInfoNameRole}>
                        <p className="adviser-name">{userName}</p>
                        <p className="adviser-position" style={{marginTop: "0px"}}>{role}</p>
                    </div>
                    <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                        <ProfileMenu userImg={userPicture}/>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Header;

